import React from 'react';
import { Trash } from '@withjoy/joykit/icons';
import { pxToRem } from '@withjoy/joykit/theme';
import { ResponsiveDialog } from '@shared/components/ResponsiveDialog';
import { Box, ButtonV2, CancelButton, SpacingStack, TextV2 } from '@withjoy/joykit';
import { drawerOverrides } from '@shared/components/ResponsiveDialog/ResponsiveDialog.styles';
import { useTranslation } from '@shared/core';

type StayZoneRemoveDialogProps = Readonly<{
  isOpen: boolean;
  onClose: () => void;
  onConfirm: () => void;
}>;

export const StayZoneRemoveDialog: React.FC<StayZoneRemoveDialogProps> = ({ isOpen, onClose, onConfirm }) => {
  const { tq } = useTranslation('stayZonesAdmin');

  return (
    <ResponsiveDialog
      isOpen={isOpen}
      onClose={onClose}
      hideDivider
      removeBodyPadding
      drawerOverrides={{
        ...drawerOverrides,
        Content: {
          props: {
            ...drawerOverrides.Content?.props,
            boxShadow: '0px -7px 16px -8px rgba(0, 0, 0, 0.3), 0px -10px 27px -5px rgba(44, 41, 37, 0.25)',
          },
        },
        Body: { props: { ...drawerOverrides.Body?.props, paddingX: 6, paddingBottom: 8, paddingTop: 8 } },
      }}
      dialogOverrides={{
        Content: { props: { width: ['100%', pxToRem(480)] } },
        Body: { props: { paddingX: 8, paddingY: 8 } },
      }}
    >
      <SpacingStack spacing={8}>
        <SpacingStack
          spacing={6}
          maxWidth={pxToRem(320)}
          marginX="auto"
        >
          <TextV2
            as="h3"
            typographyVariant="hed6"
            textAlign="center"
          >
            {tq`Are you sure you want to remove this stay zone?`}
          </TextV2>
          <TextV2
            as="p"
            typographyVariant="body2"
            color="mono12"
            textAlign="center"
          >
            {tq`This cannot be undone.`}
          </TextV2>
        </SpacingStack>
        <Box width="100%">
          <ButtonV2
            intent="destructive"
            onClick={onConfirm}
            width="100%"
            startIcon={<Trash />}
          >
            {tq`Remove`}
          </ButtonV2>
          <CancelButton
            marginRight="auto"
            onClick={onClose}
            width="100%"
            marginTop={5}
          >
            {tq`Cancel`}
          </CancelButton>
        </Box>
      </SpacingStack>
    </ResponsiveDialog>
  );
};
